module.exports = __webpack_public_path__ + "img/wbs2.a8c1cbeb.svg";